import { createVanIconComponent } from "./van"

const ServiceOutlined = createVanIconComponent("service-o")
export default ServiceOutlined
